import React, { useState, useEffect } from 'react';

/**
 * StreamingText Component
 * Renders text with a typewriter effect to simulate streaming
 *
 * @param {string} text - The full text to display
 * @param {number} speed - Milliseconds per character (default: 20)
 * @param {function} onComplete - Callback when streaming completes
 */
const StreamingText = ({ text, speed = 20, onComplete }) => {
  const [displayedText, setDisplayedText] = useState('');
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    if (currentIndex < text.length) {
      const timeout = setTimeout(() => {
        setDisplayedText((prev) => prev + text[currentIndex]);
        setCurrentIndex((prev) => prev + 1);
      }, speed);

      return () => clearTimeout(timeout);
    } else if (currentIndex === text.length && onComplete) {
      onComplete();
    }
  }, [currentIndex, text, speed, onComplete]);

  // Reset when text changes
  useEffect(() => {
    setDisplayedText('');
    setCurrentIndex(0);
  }, [text]);

  return (
    <span className="streaming-text">
      {displayedText}
      {currentIndex < text.length && (
        <span className="streaming-cursor">▋</span>
      )}
    </span>
  );
};

export default StreamingText;
